import { render } from "./Skills.vue?vue&type=template&id=d0fa6766&ts=true"
import script from "./Skills.vue?vue&type=script&lang=ts"
export * from "./Skills.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Karol\\Documents\\Github\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__